import { addMethod, object, string } from 'yup';
import { fulfilment as fulfilmentApi } from '@afosto/fulfilment/api/Fulfilment';

// eslint-disable-next-line func-names
addMethod(string, 'unknownPosition', function () {
  return this.test({
    name: 'unknownPosition',
    message: 'Unknown position',
    async test(position = '') {
      if (position) {
        const { locationId } = this.parent;

        try {
          await fulfilmentApi.viewPosition(locationId, position?.toUpperCase());
          return true;
        } catch (err) {
          return false;
        }
      }

      return true;
    },
  });
});

export default object().shape({
  position: string().unknownPosition().required(),
});
